<table mat-table class="mt-3 w-100" (matSortChange)="sortData($event)" matSort matSortActive="senItemID"
    matSortDisableClear matSortDirection="asc" [dataSource]="dataSource">
    <ng-container matColumnDef="senItemID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{translate.getLng('ARTNO')}} </th>
        <td mat-cell *matCellDef="let element"> {{element.senItemID}} </td>
    </ng-container>
    <ng-container matColumnDef="imageURL">
        <th mat-header-cell *matHeaderCellDef> {{translate.getLng('ITEM_IMAGE')}}</th>
        <td mat-cell *matCellDef="let element"> <img width="40" src="{{element.imageURL}}"> </td>
    </ng-container>
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{translate.getLng('NAME')}}</th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>
    <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{translate.getLng('QUANTITY')}}</th>
        <td mat-cell *matCellDef="let element"> {{element.quantity}} </td>
    </ng-container>
    <ng-container matColumnDef="unit">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{translate.getLng('UNIT')}} </th>
        <td mat-cell *matCellDef="let element"> {{element.unit}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
